<template>
  <article class="flex items-center px-4">
    <slot />
  </article>
</template>
